/**
 * Identifies the type of file based on the format
 */

export const FILE_TYPES = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  AUDIO: 'AUDIO',
  DOCUMENT: 'DOCUMENT',
  OTHER: 'OTHER',
};

// given a string uri of the file with extension
// this method will find out the file type
// image/video/music/doc/others
export function identifyFileType(uri) {
  if (!uri) {
    return FILE_TYPES.OTHER;
  }

  const extension = uri.split('?')[0].split('.').pop().toLowerCase();
  if (extension.length < 3 || extension.length > 4) {
    return FILE_TYPES.OTHER;
  }

  switch (extension) {
    case 'png':
    case 'jpg':
    case 'jpeg':
    case 'svg':
    case 'webp':
    case 'gif':
      return FILE_TYPES.IMAGE;
    case 'mp4':
    case 'mkv':
    case 'mov':
    case 'mpeg':
    case 'avi':
    case 'flv':
    case 'wmv':
      return FILE_TYPES.VIDEO;
    case 'mp3':
      return FILE_TYPES.AUDIO;
    case 'doc':
    case 'xdoc':
    case 'xls':
    case 'xxls':
    case 'ppt':
    case 'xppt':
    case 'txt':
      return FILE_TYPES.DOCUMENT;
    default:
      return FILE_TYPES.OTHER;
  }
}



// WEBPACK FOOTER //
// ./src/utils/file_type.js